<app-option-bar [type]="moduleType" [details]="moduleDetails"></app-option-bar>
<div class="certification-section">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
      </div>
      <div class="inner-content collapsed">
        <div class="common-section" *ngIf="jiraDefect">
          <div class="common-heading">Active defect</div>
          <div class="common-box">
            <div class="row">
              <div class="col-5">
                {{ jiraDefect.defectId }}
                <div>
                  <a target="_blank">{{ jiraDefect.defectLink }}</a>
                </div>
              </div>
              <div class="col-1">
                <div class="checkbox">
                  <label for="fix"> <input type="checkbox" id="fix" ng-model="fix" /> Fix </label>
                </div>
              </div>
              <div class="col-3">
                <div ng-if="fix">
                  Select version :
                  <select
                    name="fixVersions"
                    id="fixVersions"
                    ng-model="jiraDefect.fixVersionName"
                    ng-options="item for item in vm.jiraConfig.fixVersions track by item"
                  >
                    <option value="">-- Select --</option>
                  </select>
                </div>
              </div>
              <div class="col-3">
                <button type="button" class="btn relay-btn save" ng-click="vm.closeJiraDefect(jiraDefect)">Close defect</button>
              </div>
            </div>
          </div>
        </div>

        <div class="common-section">
          <div class="common-heading">Jira configurations</div>
          <div class="common-box">
            <form name="jiraForm" ng-submit="saveJiraConfig(jira)" novalidate>
              <div class="row">
                <div class="col-6 form-group">
                  <label for=""
                    >Components
                    <span class="error-msg">*</span>
                  </label>
                  <select
                    name="components"
                    chosen
                    id="components"
                    ng-model="jira.component"
                    class="form-control"
                    ng-options="item.value for item in vm.jiraConfig.components track by item.id"
                    required
                  >
                    <option value="">-- Select --</option>
                  </select>
                </div>

                <div class="col-6 form-group">
                  <label for="custom-field"
                    >Custom field/Method found
                    <span class="error-msg">*</span>
                  </label>
                  <select
                    name="customField"
                    chosen
                    id="custom-field"
                    ng-model="jira.customField"
                    class="form-control"
                    ng-options="item.value for item in vm.jiraConfig.customFields track by item.id"
                    required
                  >
                    <option value="">-- Select --</option>
                  </select>
                </div>

                <div class="col-6 form-group">
                  <label for="priority"
                    >Priority
                    <span class="error-msg">*</span>
                  </label>
                  <select
                    name="priority"
                    chosen
                    id="priority"
                    ng-model="jira.priority"
                    class="form-control"
                    ng-options="item.value for item in vm.jiraConfig.priority track by item.id"
                    required
                  >
                    <option value="">-- Select --</option>
                  </select>
                  <div class="checkbox">
                    <label for="log-defect"> <input type="checkbox" id="log-defect" ng-model="jira.logDefect" /> Log defect </label>
                  </div>
                </div>
                <div class="col-6 form-group">
                  <label for="assignee"
                    >Assignee
                    <span class="error-msg">*</span>
                  </label>
                  <select
                    name="assignee"
                    chosen
                    id="assignee"
                    ng-model="jira.assignee"
                    class="form-control"
                    ng-options="user.user as (user.user.displayName || user.user.userName) + ' ' + '(' + (user.user.emailId || 'IMS Service' ) + ')' for user in vm.users track by user.id"
                  >
                    <option value="">-- Select --</option>
                  </select>
                </div>
                <div class="col-md-12 text-right">
                  <button type="submit" class="btn relay-btn save" ng-disabled="jiraForm.$invalid">Save</button>
                  <button type="button" class="btn relay-btn cancel" ng-click="jira = {};">Cancel</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
